import APIService from './APIService'

const api = APIService()

export const fetchPackingTypes = payload => api.get(`/packaging_types${payload.query}`)
export const createPackingType = payload => api.post('/packaging_types', payload)
export const updatePackingType = payload => api.patch(`/packaging_types/${payload.id}`, { name: payload.name })
export const deletePackingType = payload => api.delete(`/packaging_types/${payload.id}`)
